import { Layout } from 'antd';
import styled from 'styled-components';

const { Content: AntContent } = Layout;

const Content = styled(AntContent)`
  position: relative;
  height: calc(100vh - 160px);
`;

const PageView = ({ children }) => {
  return (
    <main>
      <Content>{children}</Content>
    </main>
  );
};

export default PageView;
